// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputPasscode-module_passCodeWrapper__s45OH {
    position: absolute;
    height: 0;
    overflow: hidden;
}

.inputPasscode-module_passCodeInput__aO8mp {
    font-size: 20px;
    color: inherit;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Inputs/inputPasscode.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":[".passCodeWrapper {\n    position: absolute;\n    height: 0;\n    overflow: hidden;\n}\n\n.passCodeInput {\n    font-size: 20px;\n    color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"passCodeWrapper": `inputPasscode-module_passCodeWrapper__s45OH`,
	"passCodeInput": `inputPasscode-module_passCodeInput__aO8mp`
};
export default ___CSS_LOADER_EXPORT___;
